import React, { useState, useRef , useContext} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
  X, UploadCloud, Video, Trash2, ChevronDown,
  Home, Info, Smartphone, Tablet, Monitor
} from 'lucide-react';
import AppContext from '../../../../context/AppContext';

const SECTION_OPTIONS = [
  { value: 'hero', label: 'Hero Section', icon: Home },
  { value: 'about', label: 'About Us', icon: Info },
];

const DEVICE_OPTIONS = [
  { value: 'mobile', label: 'Mobile', icon: Smartphone },
  { value: 'tablet', label: 'Tablet', icon: Tablet },
  { value: 'desktop', label: 'Desktop', icon: Monitor },
];

const AddVideoModal = ({ onClose, onUploaded, baseUrl, defaultSection }) => {
const {authToken}= useContext(AppContext);
  const [section, setSection] = useState(defaultSection || 'hero');
  const [device, setDevice] = useState('desktop');
  const [videoName, setVideoName] = useState('');

  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const fileInputRef = useRef(null);

  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      Swal.fire({ icon: 'warning', title: 'Invalid File', text: 'Please select a valid video file.' });
      return;
    }

   const maxSizeMB = 200;

if (file.size / (1024 * 1024) > maxSizeMB) {
  Swal.fire({ 
    icon: 'warning', 
    title: 'Too Large', 
    text: `Video must be under ${maxSizeMB}MB.` 
  });
  return;
}

    setVideoFile(file);
    setVideoPreview(URL.createObjectURL(file));
  };

  const handleInputChange = (e) => handleFile(e.target.files[0]);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleRemoveFile = () => {
    setVideoFile(null);
    setVideoPreview(null);
    setProgress(0);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleSubmit = () => {
    if (!videoFile) {
      Swal.fire({ icon: 'warning', title: 'Required', text: 'Please select a video file.' });
      return;
    }

    setUploading(true);
    setProgress(0);

    const formData = new FormData();
    formData.append('video', videoFile);
    formData.append('section', section);
    formData.append('name', videoName);

const token = localStorage.getItem("token");

axios.post(`${baseUrl}/admin/upload/video`, formData, {
  headers: {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'multipart/form-data'
  },
  onUploadProgress: (evt) => {
    const percent = Math.round((evt.loaded * 100) / evt.total);
    setProgress(percent);
  }
})
      .then((res) => {
        Swal.fire({ icon: 'success', title: 'Video Added!', timer: 1800, showConfirmButton: false });

      const newVideo = res.data.video;

        onUploaded(newVideo);
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: err.response?.data?.message || 'Something went wrong while uploading.'
        });
      })
      .finally(() => setUploading(false));
  };

  return (
    <div className="pv-overlay" onClick={onClose}>
      <div className="pv-modal" onClick={(e) => e.stopPropagation()}>

        <div className="pv-modal__header">
          <div className="pv-modal__icon"><Video size={20} /></div>
          <div>
            <h3 className="pv-modal__title">Add Platform Video</h3>
            <p className="pv-modal__sub">Choose section, device size, then upload</p>
          </div>
          <button className="pv-modal__close" onClick={onClose}><X size={18} /></button>
        </div>

        <div className="pv-modal__body">

          {/* Section + Device dropdowns */}
          <div className="pv-form-row">
            <div className="pv-form-field">
              <label>Section</label>
              <div className="pv-select-wrap">
                <select value={section} onChange={(e) => setSection(e.target.value)}>
                  {SECTION_OPTIONS.map((s) => (
                    <option key={s.value} value={s.value}>{s.label}</option>
                  ))}
                </select>
                <ChevronDown size={16} className="pv-select-chevron" />
              </div>
            </div>

            {/* <div className="pv-form-field">
              <label>Device Size</label>
              <div className="pv-select-wrap">
                <select value={device} onChange={(e) => setDevice(e.target.value)}>
                  {DEVICE_OPTIONS.map((d) => (
                    <option key={d.value} value={d.value}>{d.label}</option>
                  ))}
                </select>
                <ChevronDown size={16} className="pv-select-chevron" />
              </div>
            </div> */}
          </div>

          {/* Optional name */}
          <div className="pv-form-field" style={{ marginBottom: '16px' }}>
            <label>Video Name (optional)</label>
            <input
              type="text"
              className="pv-text-input"
              placeholder="e.g. Hero Intro Clip"
              value={videoName}
              onChange={(e) => setVideoName(e.target.value)}
            />
          </div>

          {/* Upload zone / preview */}
          {!videoPreview ? (
            <div
              className={'pv-upload-zone' + (isDragging ? ' pv-upload-zone--dragging' : '')}
              onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept="video/*"
                hidden
                onChange={handleInputChange}
              />
              <div className="pv-upload-zone__icon"><UploadCloud size={26} /></div>
              <h4>Click or drag video here</h4>
<p>MP4, MOV or WebM — up to 200MB</p>
            </div>
          ) : (
            <div className="pv-preview">
              <video src={videoPreview} className="pv-preview__video" controls />

              {uploading && (
                <div className="pv-progress">
                  <div className="pv-progress__bar" style={{ width: progress + '%' }} />
                  <span className="pv-progress__label">{progress}%</span>
                </div>
              )}

              <button className="pv-remove-btn" onClick={handleRemoveFile} disabled={uploading}>
                <Trash2 size={14} /> Remove
              </button>
            </div>
          )}

        </div>

        <div className="pv-modal__footer">
          <button className="pv-cancel-btn" onClick={onClose}>Cancel</button>
          <button
            className="pv-submit-btn"
            onClick={handleSubmit}
            disabled={!videoFile || uploading}
          >
            {uploading ? <span className="pv-spinner" /> : <><UploadCloud size={15} /> Upload Video</>}
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddVideoModal;